import React from "react";

export default function CartonInfoBox() {
  return (
    <div className="flex items-center gap-1.5 bg-emerald-50/80 border border-emerald-500 text-emerald-800 text-[8px] font-medium px-2 py-1 rounded-xl animate-fadeIn">
      <svg className="w-3 h-3 text-emerald-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>هر کارتن شامل ۶ بسته ۱ کیلویی است.</span>
    </div>
  );
}